import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);
import { DEPRECATED_TIMEZONES } from '../contants';
export var getDefaultAbsoluteTime = function (timezoneName) {
    try {
        var timezone = DEPRECATED_TIMEZONES[timezoneName] || timezoneName;
        var offset = dayjs().utc().tz(timezone).utcOffset();
        var start = dayjs
            .utc()
            .subtract(1, 'day')
            .startOf('day')
            .utcOffset(offset, true)
            .format();
        var end = dayjs().startOf('day').utcOffset(offset, true).format();
        return {
            start: start,
            end: end,
        };
    }
    catch (err) {
        return null;
    }
};
export default getDefaultAbsoluteTime;
